import * as React from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import * as services from "../../store/service";
import { IAddress, ICSIDUserStatus } from "../../store/csid/types";
import { PATTERNS } from "../../util/patterns";
import { stateList } from "../../util/CommonLists";
import i18nService from "../../util/Internationalization/i18n/i18n";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import { Helmet } from "react-helmet";

interface IProps {
    closeButtonText: string;
    onCloseCallback: any;
    openAsDialog: boolean;
    submitButtonText: string;
    onSubmitCallback: any;
    displaySSNInputNumber: boolean;
    dobRequired: boolean;
    addressRequired?: boolean;
    csidUserStatus: ICSIDUserStatus;
    dispalyAdditionalHeaderMessage?: boolean;
    ignoreCSIDSubmission?: boolean;
}

const FullSSNComponent: React.FunctionComponent<IProps> = (props) => {
    const [zipCode, setZipCode] = useState(i18nService.get("ZipCode"));
    const [submitted, setSubmitted] = useState(false);

    const { t: tLang, i18n: i18nLang } = useTranslation();

    const initState = {
        "check-ssn-3-digit": "",
        "check-ssn-2-digit": "",
        "check-ssn-4-digit": "",
        "confirm-ssn-3-digit": "",
        "confirm-ssn-2-digit": "",
        "confirm-ssn-4-digit": "",
        birthDay: "1",
        birthMonth: "1",
        birthYear: new Date().getFullYear().toString(),
        ssnValid: true,
        errorMessage: tLang("dashboard.creditScore.fullSSNComp.errorMessage"),
        dobValid: true,
        notOlderMessage: tLang("dashboard.creditScore.fullSSNComp.notOlderMessage"),

        address1: "",
        address2: "",
        city: "",
        zipCode: "",
        state: "",
    };

    const status = {
        success: "success",
        error: "error",
        apiException: "api-exception",
        apiStatus: "api-status",
    };

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const isDate18orMoreYearsOld = (day: number, month: number, year: number) => {
        return new Date(year + 18, month - 1, day).getTime() <= new Date().getTime();
    };

    let strCloseButtonText = "Close";
    let strSubmitButtonText = "Submit";
    let blnOpenAsDialog = false;
    let ssnInputFieldType = "password";
    let blnDispalyAdditionalHeaderMessage = false;
    let blnIgnoreCSIDSubmission = false;
    // set default value for props, if not passed
    if (props.closeButtonText != null) {
        strCloseButtonText = props.closeButtonText;
    }
    if (props.submitButtonText != null) {
        strSubmitButtonText = props.submitButtonText;
    }
    if (props.openAsDialog != null) {
        blnOpenAsDialog = props.openAsDialog;
    }
    if (props.displaySSNInputNumber) {
        ssnInputFieldType = "text";
    }
    if (props.dispalyAdditionalHeaderMessage != null) {
        blnDispalyAdditionalHeaderMessage = props.dispalyAdditionalHeaderMessage;
    }
    if (props.ignoreCSIDSubmission != null) {
        blnIgnoreCSIDSubmission = props.ignoreCSIDSubmission;
    }
    // use form-submit-hook
    const { register, errors, reset, formState, handleSubmit, clearErrors } = useForm({
        mode: "onSubmit",
        reValidateMode: "onChange",
    });

    const { isSubmitting } = formState;
    const [isLoading, setIsLoading] = useState(false);
    const [fullSSN, setFullSSN] = useState(initState);
    // const [fullSSN, setFULLSSN] = useState({ "ssn": "", "dob": "" })
       // in case of dialog, register event for escape press
    if (blnOpenAsDialog) {
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                window.removeEventListener("keyup", () => {});
                onClose("cancel");
            }
        });
    }
    function onTextBoxChangeHandler(event: React.ChangeEvent<HTMLInputElement>) {
        onChangeHandler(event);
        let targetName = event.target.name;
        let targetValue = event.target.value;
        setSubmitted(false);
        switch (targetName) {
            case "check-ssn-3-digit":
                if (targetValue.length > 2) {
                    document.getElementById("check-ssn-2-digit")?.focus();
                }
                break;
            case "check-ssn-2-digit":
                if (targetValue.length > 1) {
                    document.getElementById("check-ssn-4-digit")?.focus();
                }
                break;
            case "check-ssn-4-digit":
                if (targetValue.length > 3) {
                    document.getElementById("confirm-ssn-3-digit")?.focus();
                }
                break;
            case "confirm-ssn-3-digit":
                if (targetValue.length > 2) {
                    document.getElementById("confirm-ssn-2-digit")?.focus();
                }
                break;
            case "confirm-ssn-2-digit":
                if (targetValue.length > 1) {
                    document.getElementById("confirm-ssn-4-digit")?.focus();
                }
                break;
            default:
                break;
        }
    }

    function onChangeHandler(event: any) {
        setSubmitted(false);
        clearErrors();
        const elName = event.currentTarget.name;
        setFullSSN({ ...fullSSN, [elName as string]: event.currentTarget.value });
    }

    const invokePostSubmitCallback = (status: string, data: any) => {
        if (props.onSubmitCallback != null) {
            props.onSubmitCallback({ status: status, data: data });
        }
    };
//Get BlackBox key from config.js and loader.js
const  send_bb=()=> {
  var blackbox = "";
  try {
     blackbox = window.IGLOO.getBlackbox().blackbox;
  } catch (e) {}
   return blackbox;
 }
    // handle form submit
    const onSubmit = () => {
        const ssn = fullSSN["check-ssn-3-digit"] + fullSSN["check-ssn-2-digit"] + fullSSN["check-ssn-4-digit"];
        const confirmSSN = fullSSN["confirm-ssn-3-digit"] + fullSSN["confirm-ssn-2-digit"] + fullSSN["confirm-ssn-4-digit"];
        if (!submitted) {
            if (ssn === confirmSSN) {
                setFullSSN({ ...fullSSN, ssnValid: true });
                let dob = "";
                if (props.dobRequired) {
                    dob = fullSSN.birthMonth + "/" + fullSSN.birthDay + "/" + fullSSN.birthYear;
                    const tempDay = parseInt(fullSSN.birthDay, 10);
                    const tempMonth = parseInt(fullSSN.birthMonth, 10);
                    const tempYear = parseInt(fullSSN.birthYear, 10);
                    const is18YearsOld = isDate18orMoreYearsOld(tempDay, tempMonth, tempYear);
                    if (!is18YearsOld) {
                        // show error
                        setFullSSN({ ...fullSSN, dobValid: false });
                        return;
                    } else {
                        setFullSSN({ ...fullSSN, dobValid: true });
                    }
                }
                const blackBoxKey=send_bb();
                // check if we should invoke the CSID submission
                if (!blnIgnoreCSIDSubmission) {
                    // set the loader into UI;
                    setIsLoading(true);

                    if (props.csidUserStatus?.csidActivationStatus === "ACTIVATED") {
                        services
                            .updateUserinCSID(ssn, dob)
                            .then((data) => {
                                // remove loader from UI
                                setIsLoading(false);
                                if (data["status-code"] === "200") {
                                    invokePostSubmitCallback(status.success, { ssn: ssn, dob: dob, detail: data,blackBoxKey:blackBoxKey });                                 } else {
                                    invokePostSubmitCallback(status.error, { reason: status.apiStatus, detail: data });
                                }
                            })
                            .catch((error) => {
                                setIsLoading(false);
                                invokePostSubmitCallback(status.error, { reason: status.apiException, detail: error });
                            });
                    } else {
                        // send http request to enroll the user in CSID.
                        services
                            .enrollUserinCSID(ssn, dob)
                            .then((data) => {
                                // remove loader from UI
                                setIsLoading(false);
                                if (data["status-code"] === "200") {
                                    invokePostSubmitCallback(status.success, { ssn: ssn, dob: dob, detail: data, blackBoxKey:blackBoxKey });
                                } else {
                                    invokePostSubmitCallback(status.error, { reason: status.apiStatus, detail: data });
                                }
                            })
                            .catch((error) => {
                                setIsLoading(false);
                                invokePostSubmitCallback(status.error, { reason: status.apiException, detail: error });
                            });
                    }
                } else {
                    // if we need to to ignore the CSID submission,
                    // then invoke the success
                    //invokePostSubmitCallback(status.success, { 'ssn': ssn, 'dob': dob, 'detail': {} });
                    invokePostSubmitCallback(status.success, {
                        ssn: ssn,
                        dob: dob,
                        detail: {},
                        blackBoxKey: blackBoxKey ,
                        address: {
                            address1: fullSSN.address1,
                            address2: fullSSN.address2,
                            city: fullSSN.city,
                            state: fullSSN.state,
                            zipCode: fullSSN.zipCode,
                        } as IAddress,
                    });
                }
            } else {
                setFullSSN({ ...fullSSN, ssnValid: false });
            }
        }
        setSubmitted(true);
    };

    const onClose = (reason?: string) => {
        // execute method passed as props for onCloseButtonClick
        if (props.onCloseCallback != null) {
            props.onCloseCallback({ reason: reason == null ? "close" : "cancel" });
        }
    };
    return (
        <React.Fragment>
            <div className={`${isLoading && "loading"}`}>
                <form id="form-fullssn" onSubmit={handleSubmit(onSubmit)}>
                    <div className="dialog-header">
                        {props.openAsDialog && (
                            <div className="dialog-icon status-default">
                                <RenderIcons iconName="user-shield" />
                            </div>
                        )}
                        <h1>{tLang("dashboard.creditScore.fullSSNComp.verification")}</h1>
                    </div>

                    <div className="dialog-body">
                        {blnDispalyAdditionalHeaderMessage && (
                            <div className="box-description">
                                <h2>{tLang("dashboard.creditScore.fullSSNComp.header")}</h2>
                                <p>{tLang("dashboard.creditScore.fullSSNComp.additionalHeaderMessage2")}</p>
                            </div>
                        )}
                        <div className="form-row">
                            <div className="form-input">
                                <div className="row">
                                <div className="social-num">
                                            <input
                                                aria-required="true"
                                                type="hidden"
                                                name="ioBlackBox"
                                                id="ioBlackBox"
                                                className="inputbox"
                                                autoComplete="off"
                                                autoFocus={true}
                                                aria-label="Enter your blackbox details"
                                            />
                                         </div>
                                    <div className="form-label">
                                        <label className="control-label" htmlFor="check-ssn-3-digit">
                                            {tLang("dashboard.creditScore.fullSSNComp.enterFullSSN")}
                                            <span className="required" title="Mandatory">
                                                {" "}
                                                *{" "}
                                            </span>
                                        </label>
                                    </div>
                                    <div className="space-divider margin-top-l"></div>
                                    <div className="form-input row">
                                        <div role="alert" aria-label="Enter your Social Security Number" className="col-xs-4 col-sm-2 col-no-gutter">
                                            <input
                                                aria-required="true"
                                                ref={register({ required: true, pattern: /(^(?!0{3})(\d{3})(?!-?0{3})(|-\d{3})?$)/ })}
                                                type={ssnInputFieldType}
                                                name="check-ssn-3-digit"
                                                id="check-ssn-3-digit"
                                                maxLength={3}
                                                className="inputbox"
                                                autoComplete="off"
                                                autoFocus={true}
                                                onChange={onTextBoxChangeHandler}
                                            />
                                        </div>
                                        <div role="alert" className="col-xs-4 col-sm-2 col-gutter-horizontal">
                                            <label htmlFor="check-ssn-2-digit" className="hide-label">Enter your Social Security Number &nbsp;</label>
                                            <input
                                                aria-required="true"
                                                ref={register({ required: true, pattern: /(^(\d{2})(?!-?0{2})(|-\d{2})?$)/ })}
                                                type={ssnInputFieldType}
                                                name="check-ssn-2-digit"
                                                id="check-ssn-2-digit"
                                                maxLength={2}
                                                autoComplete="off"
                                                className="inputbox"
                                                onChange={onTextBoxChangeHandler}
                                            />
                                        </div>
                                        <div role="alert" className="col-xs-4 col-sm-2 col-no-gutter">
                                            <label htmlFor="check-ssn-4-digit" className="hide-label">Enter your Social Security Number &nbsp; &nbsp;</label>
                                            <input
                                                aria-required="true"
                                                ref={register({ required: true, pattern: /(^(?!0{4})(\d{4})(?!-?0{4})(|-\d{4})?$)/ })}
                                                type={ssnInputFieldType}
                                                name="check-ssn-4-digit"
                                                id="check-ssn-4-digit"
                                                maxLength={4}
                                                autoComplete="off"
                                                className="inputbox"
                                                onChange={onTextBoxChangeHandler}
                                            />
                                        </div>
                                    </div>
                                    {({ ...errors["check-ssn-3-digit"] }.type === "required" ||
                                        { ...errors["check-ssn-2-digit"] }.type === "required" ||
                                        { ...errors["check-ssn-4-digit"] }.type === "required") && (
                                        <span className="form-error">{tLang("dashboard.creditScore.fullSSNComp.requiredErrorMessage")}</span>
                                    )}

                                    {({ ...errors["check-ssn-3-digit"] }.type === "pattern" ||
                                        { ...errors["check-ssn-2-digit"] }.type === "pattern" ||
                                        { ...errors["check-ssn-4-digit"] }.type === "pattern") && (
                                        <span className="form-error"> {tLang("dashboard.creditScore.fullSSNComp.invalidErrorMessage")}</span>
                                    )}
                                </div>
                                <div className="row">
                                    <div className="form-label">
                                        <label className="control-label" htmlFor="confirm-ssn-3-digit">
                                            {tLang("dashboard.creditScore.fullSSNComp.confirmSSN")}
                                            <span className="required" title="Mandatory">
                                                {" "}
                                                *{" "}
                                            </span>
                                        </label>
                                    </div>
                                    <div className="space-divider margin-top-l"></div>
                                    <div className="form-input row">
                                        <div role="alert" className="col-xs-4 col-sm-2 col-no-gutter">
                                            <input
                                                aria-required="true"
                                                ref={register({ required: true, pattern: /(^(?!0{3})(\d{3})(?!-?0{3})(|-\d{3})?$)/ })}
                                                type={ssnInputFieldType}
                                                name="confirm-ssn-3-digit"
                                                id="confirm-ssn-3-digit"
                                                maxLength={3}
                                                className="inputbox"
                                                autoComplete="off"
                                                onChange={onTextBoxChangeHandler}
                                            />
                                        </div>
                                        <div role="alert" className="col-xs-4 col-sm-2 col-gutter-horizontal">
                                            <label htmlFor="confirm-ssn-2-digit" className="hide-label">Confirm your Social Security Number &nbsp;</label>
                                            <input
                                                aria-required="true"
                                                ref={register({ required: true, pattern: /(^(\d{2})(?!-?0{2})(|-\d{2})?$)/ })}
                                                type={ssnInputFieldType}
                                                name="confirm-ssn-2-digit"
                                                id="confirm-ssn-2-digit"
                                                maxLength={2}
                                                autoComplete="off"
                                                className="inputbox"
                                                onChange={onTextBoxChangeHandler}
                                            />
                                        </div>
                                        <div role="alert" className="col-xs-4 col-sm-2 col-no-gutter">
                                            <label htmlFor="confirm-ssn-4-digit" className="hide-label">Confirm your Social Security Number &nbsp; &nbsp;</label>
                                            <input
                                                aria-required="true"
                                                ref={register({ required: true, pattern: /(^(?!0{4})(\d{4})(?!-?0{4})(|-\d{4})?$)/ })}
                                                type={ssnInputFieldType}
                                                name="confirm-ssn-4-digit"
                                                id="confirm-ssn-4-digit"
                                                maxLength={4}
                                                autoComplete="off"
                                                className="inputbox"
                                                onChange={onChangeHandler}
                                            />
                                        </div>
                                    </div>
                                    {({ ...errors["confirm-ssn-3-digit"] }.type === "required" ||
                                        { ...errors["confirm-ssn-2-digit"] }.type === "required" ||
                                        { ...errors["confirm-ssn-4-digit"] }.type === "required") && (
                                        <span className="form-error">{tLang("dashboard.creditScore.fullSSNComp.confirmSSNRequired")}</span>
                                    )}

                                    {({ ...errors["confirm-ssn-3-digit"] }.type === "pattern" ||
                                        { ...errors["confirm-ssn-2-digit"] }.type === "pattern" ||
                                        { ...errors["confirm-ssn-4-digit"] }.type === "pattern") && (
                                        <span className="form-error"> {tLang("dashboard.creditScore.fullSSNComp.invalidErrorMessage")}</span>
                                    )}
                                </div>
                                {!fullSSN.ssnValid && <p style={{ color: "red" }}>{fullSSN.errorMessage}</p>}
                            </div>
                        </div>

                        {props.dobRequired && (
                            <div className="form-row">
                                <div className="form-label">
                                    <label htmlFor="dob">
                                        Date of Birth{" "}
                                        <span className="required" title="Mandatory">
                                            {" "}
                                            *{" "}
                                        </span>{" "}
                                    </label>
                                </div>
                                <div className="form-input row">
                                    <div className="col-xs-4 col-sm-3 col-no-gutter">
                                        <select
                                            ref={register}
                                            name="birthMonth"
                                            className="inputbox"
                                            id="dob"
                                            onChange={onChangeHandler}
                                            value={fullSSN.birthMonth}
                                            aria-required="true"
                                        >
                                            {months.map((month, index) => {
                                                return (
                                                    <option key={month} value={index + 1}>
                                                        {month}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                    <div className="col-xs-4 col-sm-3 col-gutter-horizontal">
                                        <select
                                            ref={register}
                                            name="birthDay"
                                            className="inputbox"
                                            id="label-dob-day"
                                            onChange={onChangeHandler}
                                            value={fullSSN.birthDay}
                                            aria-label="Date of Birth Day"
                                            aria-required="true"
                                        >
                                            {Array(31)
                                                .fill(null)
                                                .map((value, index) => {
                                                    return (
                                                        <option key={index + 1} value={index + 1}>
                                                            {index + 1}
                                                        </option>
                                                    );
                                                })}
                                        </select>
                                    </div>
                                    <div className="col-xs-4 col-sm-3 col-no-gutter">
                                        <select
                                            ref={register}
                                            name="birthYear"
                                            className="inputbox"
                                            id="label-dob-year"
                                            onChange={onChangeHandler}
                                            value={fullSSN.birthYear}
                                            aria-label="Date of Birth Year"
                                            aria-required="true"
                                        >
                                            {Array(115)
                                                .fill(null)
                                                .map((value, index) => {
                                                    const optionValue = new Date().getFullYear() - index;
                                                    return (
                                                        <option key={optionValue} value={optionValue}>
                                                            {optionValue}
                                                        </option>
                                                    );
                                                })}
                                        </select>
                                    </div>
                                </div>
                                {!fullSSN.dobValid && <p style={{ color: "red" }}>{fullSSN.notOlderMessage}</p>}
                            </div>
                        )}

                        {props.addressRequired && (
                            <div className="form-row">
                                <div className="form-input">
                                    <div className="row">
                                        <div className="form-label">
                                            <label className="control-label" htmlFor="label-address1">
                                                Street
                                                <span className="required" title="Mandatory">
                                                    {" "}
                                                    *{" "}
                                                </span>
                                            </label>
                                        </div>
                                        <div className="space-divider margin-top-l"></div>
                                        <div className="form-input row">
                                            <div role="alert" className="col-xs-12 col-no-gutter">
                                                <input
                                                    aria-required="true"
                                                    type="text"
                                                    className="inputbox"
                                                    id="label-address1"
                                                    name="address1"
                                                    placeholder="Address Line 1"
                                                    ref={register({ pattern: PATTERNS.STREETADDRESS.pattern, required: true })}
                                                    maxLength={100}
                                                    onChange={onChangeHandler}
                                                />
                                            </div>
                                        </div>
                                        {errors.address1 && errors.address1.type === "pattern" && (
                                            <span className="form-error">{PATTERNS.STREETADDRESS.message}</span>
                                        )}
                                        {errors.address1 && errors.address1.type === "required" && (
                                            <span className="form-error">{tLang("dashboard.creditScore.fullSSNComp.streetNameRequried")}</span>
                                        )}
                                    </div>

                                    <div className="row">
                                        <div className="form-label">
                                        </div>
                                        <div className="space-divider margin-top-l"></div>
                                        <div className="form-input row">
                                            <div role="alert" className="col-xs-12 col-no-gutter">
                                                <input
                                                    aria-required="true"
                                                    type="text"
                                                    className="inputbox"
                                                    id="label-address2"
                                                    name="address2"
                                                    placeholder="Address Line 2 (Optional)"
                                                    ref={register({ pattern: PATTERNS.STREETADDRESS.pattern })}
                                                    maxLength={100}
                                                    onChange={onChangeHandler}
                                                    aria-label="Address Line 2"
                                                />
                                            </div>
                                        </div>
                                        {errors.address2 && errors.address2.type === "pattern" && (
                                            <span className="form-error">{PATTERNS.STREETADDRESS.message}</span>
                                        )}
                                    </div>

                                    <div className="row">
                                        <div className="form-label">
                                            <label className="control-label" htmlFor="label-city">
                                                City
                                                <span className="required" title="Mandatory">
                                                    {" "}
                                                    *{" "}
                                                </span>
                                            </label>
                                        </div>
                                        <div className="space-divider margin-top-l"></div>
                                        <div className="form-input row">
                                            <div role="alert" className="col-xs-12 col-no-gutter">
                                                <input
                                                    aria-required="true"
                                                    type="text"
                                                    className="inputbox"
                                                    id="label-city"
                                                    name="city"
                                                    placeholder="City"
                                                    ref={register({ required: true, pattern: PATTERNS.CITY.pattern })}
                                                    maxLength={20}
                                                    onChange={onChangeHandler}
                                                />
                                            </div>
                                        </div>
                                        {errors.city && errors.city.type === "required" && (
                                            <span className="form-error">{tLang("dashboard.creditScore.fullSSNComp.cityRequired")}</span>
                                        )}
                                        {errors.city && errors.city.type === "pattern" && (
                                            <span className="form-error"> {tLang("dashboard.creditScore.fullSSNComp.cityInvalid")}</span>
                                        )}
                                    </div>

                                    <div className="row">
                                        <div className="form-label">
                                            <label className="control-label" htmlFor="label-state">
                                                State
                                                <span className="required" title="Mandatory">
                                                    {" "}
                                                    *{" "}
                                                </span>
                                            </label>
                                        </div>
                                        <div className="space-divider margin-top-l"></div>
                                        <div className="form-input row">
                                            <div role="alert" className="col-xs-12 col-no-gutter">
                                                <select
                                                    aria-required="true"
                                                    className="inputbox"
                                                    id="label-state"
                                                    name="state"
                                                    ref={register({ required: true, validate: (value) => value !== "---" })}
                                                    onChange={onChangeHandler}
                                                >
                                                    {stateList.map((val: any) => (
                                                        <option key={val.name} value={val.value}>
                                                            {val.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        {errors["state"] && errors["state"].type === "validate" && (
                                            <span className="form-error">{tLang("dashboard.creditScore.fullSSNComp.stateRequired")}</span>
                                        )}
                                    </div>

                                    <div className="row">
                                        <div className="form-label">
                                            <label className="control-label" htmlFor="label-zipCode">
                                                {zipCode.Label}
                                                <span className="required" title="Mandatory">
                                                    {" "}
                                                    *{" "}
                                                </span>
                                            </label>
                                        </div>
                                        <div className="space-divider margin-top-l"></div>
                                        <div className="form-input row">
                                            <div role="alert" className="col-xs-12 col-no-gutter">
                                                <input
                                                    aria-required="true"
                                                    type="text"
                                                    className="inputbox"
                                                    id="label-zipCode"
                                                    name="zipCode"
                                                    placeholder={zipCode.Label}
                                                    ref={register({ required: true, pattern: PATTERNS[zipCode.Pattern].pattern })}
                                                    maxLength={zipCode.MaxLength}
                                                    onChange={onChangeHandler}
                                                />
                                            </div>
                                        </div>
                                        {errors.zipCode && errors.zipCode.type === "required" && (
                                            <span className="form-error">
                                                {tLang("dashboard.creditScore.fullSSNComp.zipCodeRequired", { zipCode: zipCode.Label })}
                                            </span>
                                        )}
                                        {errors.zipCode && errors.zipCode.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("dashboard.creditScore.fullSSNComp.zipCodeInvalid", { zipCode: zipCode.Label })}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="dialog-footer">
                        <div className="row between-xs">
                            <div className="col-xs col-no-gutter flex-grow-null">
                               </div>
                            <div className="col-xs col-no-gutter flex-grow-null">
                                <button type="submit" className="btn-default btn-primary" disabled={Object.keys(errors).length > 0 || isSubmitting}>
                                    <span className="btn-text">{strSubmitButtonText}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <Helmet>
                <script src="js/config.js" type="text/javascript" />
                <script src="js/loader_only.js" type="text/javascript" />
            </Helmet>
        </React.Fragment>
    );
};

export default FullSSNComponent;
